import {
  disableVerticalSwipes,
  expandViewport,
  init,
  mountSwipeBehavior,
  mountThemeParams,
} from '@telegram-apps/sdk-react';

import { restoreInitDataSafe } from './initData';
import { installTelegramMock } from './mock';
import { setupSafeArea } from './safeArea';

let configured = false;

/**
 * Удалось ли сконфигурировать SDK. Спрашивать обязан каждый, кто трогает
 * нативные элементы: вне Telegram `isAvailable()` у компонентов не возвращает
 * `false`, а бросает `ERR_UNKNOWN_ENV` — и непроверенный вызов роняет экран
 * целиком.
 *
 * Ловится это только живым браузером: в jsdom SDK до этой ветки не доходит, а
 * в самом Telegram её не бывает. Воспроизводится перезагрузкой страницы под
 * `pnpm dev` — мок ставится один раз, а после F5 `isTMA` уже видит его следы
 * в sessionStorage и заново не ставит, тогда как `init()` всё равно падает.
 */
export function isTelegramConfigured(): boolean {
  return configured;
}

/**
 * Инициализация Telegram-слоя. Вызывается один раз на старте приложения
 * (src/app/bootstrap.ts).
 *
 * Вне Telegram и без мока `init()` бросает, потому что внутри пытается
 * определить версию через `retrieveLaunchParams()`. Это ожидаемо в обычном
 * браузере — приложение обязано подняться и без нативных Telegram-элементов,
 * поэтому единственный throw ловится здесь, а не всплывает выше.
 */
export function initTelegram(options: { initDataRaw?: string } = {}): void {
  // no-op вне DEV и внутри настоящего Telegram. `initDataRaw` передаётся только
  // в живом дев-режиме: там строку подписывает dev-сервер, и она проходит
  // проверку на бэкенде, в отличие от самодельного мока.
  installTelegramMock(options.initDataRaw);

  configured = true;
  try {
    init();
  } catch {
    configured = false;
  }

  restoreInitDataSafe();

  // Резерв применяется в любом случае; уточняется настоящими значениями,
  // только если SDK удалось сконфигурировать.
  setupSafeArea();

  if (!configured) return;

  if (mountSwipeBehavior.isAvailable()) {
    mountSwipeBehavior();
    // Без этого свайп по карточке закрывает всё приложение — требование, не улучшение.
    if (disableVerticalSwipes.isAvailable()) disableVerticalSwipes();
  }

  if (expandViewport.isAvailable()) expandViewport();

  // Палитра у игры своя (tailwind.config.js) и от темы Telegram не зависит:
  // читаем themeParams, но CSS-переменные из них не биндим, чтобы смена
  // системной темы не вызывала перекрас экрана.
  if (mountThemeParams.isAvailable()) mountThemeParams();
}
